@if (isLoading) {
  <div>
    <my-spinner></my-spinner>
  </div>
} @else {
  <div>
    @for (code of chosenLanguageCodes; track code) {
      <my-ibox>
        <div class="my-ibox-title">
          <h5>{{languages[code].langName}} {{'version' | translate}}</h5>
        </div>
        <div class="my-ibox-content">
          <label class="label-block">
            Name
            <span class="text-muted ">{{'The translated name of your policy' | translate}}</span>
            <input type="text" class="form-control" placeholder="My Policy" [(ngModel)]="languages[code].name"
              [disabled]="isUpdating"/>
          </label>
          <label class="label-block">
            {{'Policy text' | translate}}
            <span class="text-muted">{{'This is where you put your policy\'s content.' | translate}}</span>
          </label>
          <ckeditor [editor]="Editor" [config]="editorConfig" [(ngModel)]="languages[code].text" [disabled]="isUpdating"></ckeditor>
        </div>
      </my-ibox>
    }
    <my-ibox [hasTitle]="false">
      <div class="my-ibox-content buttons">
        @if (!isEditing) {
          <button type="button" (click)="create()" title="save" class="btn btn-primary btn-sm">
            <i class="far fa-save"></i> {{'Create draft' | translate}}
          </button>
        }
        @if (isEditing) {
          <button type="button" (click)="create()" title="save" class="btn btn-primary btn-sm">
            <i class="far fa-save"></i> {{'Save draft' | translate}}
          </button>
        }
        @if (isEditing) {
          <button type="button" (click)="publish()" title="save" class="btn btn-primary btn-sm">
            <i class="fas fa-upload"></i> {{'Publish' | translate}}
          </button>
        }
      </div>
    </my-ibox>
  </div>
}
